import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Vue from 'vue'; //引入百度地图组件

import BaiduMap from 'vue-baidu-map';
Vue.use(BaiduMap, {
  // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
  ak: 'sUr6rBZNC2NNwHlpcxsGI7hMBDGKM9Ws'
});
import pageUtils from '@/js/page/pageUtil.js';
import utils from '@/js/utils/util.js';
export default {
  name: 'kw_map_drawing',
  props: {
    //地图图形主键数组
    // value: {
    //   type: Array,
    //   default: function(){return[]}
    // },
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    pageSetInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    dataInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    //可绘制的图形类型
    drawingType: {
      type: Array,
      defalut: [1, 2, 3, 4, 5, 6]
    },
    //可绘制的图形个数
    maxNum: {
      type: Number,
      defalut: 0
    },
    //编辑状态  1:编辑  2:查看
    editType: {
      type: Number,
      default: 1
    },
    nowCenter: {
      type: Object,
      default: function _default() {
        return {
          lng: 116.404,
          lat: 39.915
        };
      }
    },
    //圆半径 
    circleRadius: {
      type: Number,
      default: 50
    }
  },
  data: function data() {
    return {
      ifLoad: false,
      //地图图形对应的数据数组
      valueInfo: [],
      //图形类型数组
      drawingTypeInfo: [{
        name: "点",
        value: 1
      }, {
        name: "海量点",
        value: 2
      }, {
        name: "折线",
        value: 3
      }, {
        name: "多边形",
        value: 4
      }, {
        name: "圆形",
        value: 5
      }, {
        name: "标签",
        value: 6
      }],
      //当前要新增的图形类型
      nowDrawingType: 1,
      clickLocation: {
        lng: 0,
        lat: 0
      },

      /**
       * 弹出层组件的信息
       */
      dialogInfo: {
        ifLoad: false
      },
      keyword: "",
      mapCenter: {
        lng: 114.41728300,
        lat: 36.11253900
      }
    };
  },
  created: function created() {},
  mounted: function mounted() {
    if (this.value.styleSet) {
      if (this.value.styleSet.drawingType) {
        this.nowDrawingType = this.value.styleSet.drawingType;
      }

      if (this.value.styleSet.initKeyWord) {
        this.keyword = this.value.styleSet.initKeyWord;
      }

      if (this.dataInfo && this.dataInfo["INIT_KEYWORD"]) {
        this.keyword = this.dataInfo["INIT_KEYWORD"];
      }
    }

    this.loadJsonInfoFromDb(); //根据图形主键数组 加载地图图形数据
  },
  beforeDestroy: function beforeDestroy() {},
  destroyed: function destroyed() {},
  watch: {},
  computed: {},
  components: {},
  methods: {
    openMapDialog: function openMapDialog() {
      this.dialogInfo.ifLoad = true;
    },
    closeMapDialog: function closeMapDialog() {
      this.dialogInfo.ifLoad = false;
    },

    /**从后台数据库中加载数据 */
    loadJsonInfoFromDb: function loadJsonInfoFromDb() {
      var that = this;

      if (that.value.defaultCheckValue) {
        var toHtData = {};
        toHtData.tableInfo = '{"MAP_DRAWING":[{"MAP_DRAWING_POINT":[]}]}';
        toHtData.mainId = that.value.defaultCheckValue;
        var loading = that.$loading({
          lock: true,
          text: '加载数据中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        var url = "wxXcxSet_getJsonInfoFromDb.do"; //根据pageId获取列表页面的设置信息 获取列表页面的数据信息

        utils.request(that, {
          url: url,
          //仅为示例，并非真实的接口地址
          data: toHtData,
          success: function success(res) {
            loading.close();
            console.log("res.data=======================", res.data);
            var loadHtJson = res.data;
            var MAP_DRAWING = loadHtJson.MAP_DRAWING;
            var valueInfo = [];
            MAP_DRAWING.forEach(function (valueOne) {
              var path = [];

              if (valueOne.MAP_DRAWING_POINT) {
                valueOne.MAP_DRAWING_POINT.forEach(function (one) {
                  path.push({
                    "lng": one.LONGITUDE,
                    "lat": one.LATITUDE
                  });
                });
              }

              valueInfo.push({
                "MD_NAME": valueOne.MD_NAME,
                "ZD_DRAWING_TYPE": valueOne.ZD_DRAWING_TYPE,
                "MD_RADIUS": valueOne.MD_RADIUS,
                "MAP_CENTER_LNG": valueOne.MAP_CENTER_LNG,
                "MAP_CENTER_LAT": valueOne.MAP_CENTER_LAT,
                "path": path
              });

              if (valueOne.MAP_CENTER_LNG > 0) {// that.mapCenter.lng = valueOne.MAP_CENTER_LNG
                // that.mapCenter.lat = valueOne.MAP_CENTER_LAT
              }
            });
            that.valueInfo = valueInfo;
            that.ifLoad = true;
          },
          error: function error() {
            loading.close(); // 保存失败

            that.$message({
              message: "服务器出现问题,请重试或者联系管理员",
              type: 'error'
            });
          }
        });
      } else {
        that.ifLoad = true;
      }
    },

    /**保存数据到后台 */
    saveJsonInfoToDb: function saveJsonInfoToDb() {
      var that = this;
      var toHtData = {};
      toHtData.tableName = 'MAP_DRAWING';
      var toHtJsonInfo = [];
      var valueInfo = that.valueInfo;
      var mapCenter = {};
      valueInfo.forEach(function (valueOne) {
        var path = [];
        console.log("valueInfo====================", valueInfo, valueOne.path);

        if (valueOne.path) {
          valueOne.path.forEach(function (one) {
            path.push({
              "LONGITUDE": one.lng,
              "LATITUDE": one.lat
            });
            mapCenter.lng = one.lng;
            mapCenter.lat = one.lat;
          });
        }

        toHtJsonInfo.push({
          "MD_NAME": valueOne.MD_NAME,
          "ZD_DRAWING_TYPE": valueOne.ZD_DRAWING_TYPE,
          "MD_RADIUS": valueOne.MD_RADIUS,
          "MAP_CENTER_LNG": mapCenter.lng,
          "MAP_CENTER_LAT": mapCenter.lat,
          "MAP_DRAWING_POINT": path
        });
      });
      toHtData.jsonStr = JSON.stringify(toHtJsonInfo);
      console.log("jsonStr====================", toHtJsonInfo);
      var loading = that.$loading({
        lock: true,
        text: '保存数据中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      var url = "wxXcxSet_saveJsonInfoToDb.do"; //根据pageId获取列表页面的设置信息 获取列表页面的数据信息

      utils.request(that, {
        url: url,
        //仅为示例，并非真实的接口地址
        data: toHtData,
        success: function success(res) {
          loading.close();
          console.log("res=======================", res);
          that.value.defaultCheckValue = res.data;
          that.closeMapDialog();
        },
        error: function error() {
          loading.close(); // 保存失败

          that.$message({
            message: "服务器出现问题,请重试或者联系管理员",
            type: 'error'
          });
        }
      });
    },
    //选中当前要增加的图形
    chooseDrawingType: function chooseDrawingType(drawingType) {
      this.nowDrawingType = drawingType;
    },
    //添加一个绘制图形
    addDrawing: function addDrawing(e) {
      console.log("--e--", e);
      this.clickLocation.lng = e.point.lng;
      this.clickLocation.lat = e.point.lat;
      var ifCanAdd = true;
      var valueInfo = this.valueInfo;
      console.log("valueInfo==================", valueInfo);

      if (this.maxNum > 0 && valueInfo.length > this.maxNum) {
        ifCanAdd = false;
      }

      if (ifCanAdd) {
        var drawingType = this.nowDrawingType;
        var name = this.drawingTypeInfo[drawingType - 1].name + this.valueInfo.length;
        var valueOne = {
          MD_NAME: name,
          ZD_DRAWING_TYPE: drawingType,
          MD_RADIUS: this.circleRadius,
          path: []
        }; //当前中心位置 nowCenter

        var nowCenter = this.clickLocation; //海量点

        if (drawingType == 1) {
          valueOne.path.push({
            lng: nowCenter.lng + 0,
            lat: nowCenter.lat + 0
          });
        } //海量点


        if (drawingType == 2) {
          valueOne.path.push({
            lng: nowCenter.lng + 0,
            lat: nowCenter.lat + 0
          });
        }

        if (drawingType == 3) {
          valueOne.path.push({
            lng: nowCenter.lng,
            lat: nowCenter.lat
          });
          valueOne.path.push({
            lng: nowCenter.lng + 0.001,
            lat: nowCenter.lat + 0.01
          });
          valueOne.path.push({
            lng: nowCenter.lng + 0.023,
            lat: nowCenter.lat - 0.008
          });
        } //多边形


        if (drawingType == 4) {
          valueOne.path.push({
            lng: nowCenter.lng - 0.008,
            lat: nowCenter.lat - 0.008
          });
          valueOne.path.push({
            lng: nowCenter.lng + 0.008,
            lat: nowCenter.lat - 0.008
          });
          valueOne.path.push({
            lng: nowCenter.lng + 0.008,
            lat: nowCenter.lat + 0.008
          });
          valueOne.path.push({
            lng: nowCenter.lng - 0.008,
            lat: nowCenter.lat + 0.008
          });
        } //圆


        if (drawingType == 5) {
          valueOne.path.push({
            lng: nowCenter.lng + 0,
            lat: nowCenter.lat + 0
          });
        } //标签


        if (drawingType == 6) {
          valueOne.path.push({
            lng: nowCenter.lng + 0,
            lat: nowCenter.lat + 0
          });
        }

        valueInfo.push(valueOne);
      } else {
        this.$message.error('图形个数已经大于' + this.maxNum + ',不可新增图形');
      }

      console.log("valueInfo============add ======", valueInfo);
    },
    //多边形、拆线使用
    updatePolygonPath: function updatePolygonPath(e, valueInfoOne) {
      valueInfoOne.path = e.target.getPath();
    },
    //删除多边形
    delDraw: function delDraw(e, valueInfoOne, valueInfoIndex) {
      this.valueInfo.splice(valueInfoIndex, 1); // e.target.remove();

      console.log("-valueInfo---", this.valueInfo);
    },
    //圆形
    updateCirclePath: function updateCirclePath(e, valueInfoOne) {
      valueInfoOne.path = [e.target.getCenter()];
      valueInfoOne.MD_RADIUS = e.target.getRadius();
    },
    //折线添加坐标点
    addPolylinePoint: function addPolylinePoint(valueInfoOne) {
      valueInfoOne.path.push({
        lng: nowCenter.lng,
        lat: nowCenter.lat
      });
    } // //海量点击事件
    // clickHandler (e) {
    //   alert(`单击点的坐标为：${e.point.lng}, ${e.point.lat}`);
    // },

  }
};